// WHY [BOL-RULE-CARD-WORDING-001]: the human saw the same sentence repeated on a
// "Save rule" approval card (title, "Why now" brief and the rule box) and could
// not tell what saving would do. The brief now explains the decision instead of
// repeating the rule, and the rule box shows each distinct line once. Nothing
// about the proposal, its effect or approval changes. Falsifier: a rule card
// repeats the rule text in its brief, or hides a distinct required action.
const normalizeRuleText = (text: string): string =>
  text.normalize("NFKC").toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();

export const RULE_BRIEF_FALLBACK =
  "Luna wants to keep this as a saved rule. Approving records it in the business rules as a new version; nothing is sent and no task is created.";

export function repeatsRule(brief: string, ...ruleTexts: readonly string[]): boolean {
  const candidate = normalizeRuleText(brief);
  if (!candidate) return true;
  return ruleTexts.some((rule) => {
    const normalized = normalizeRuleText(rule);
    return normalized.length > 0 && (candidate === normalized || candidate.includes(normalized) || normalized.includes(candidate));
  });
}

export function ruleBrief(whyNow: string, policy: Readonly<{ title: string; requiredAction: string }>, proposalTitle: string): string {
  return repeatsRule(whyNow, policy.title, policy.requiredAction, proposalTitle) ? RULE_BRIEF_FALLBACK : whyNow;
}

export function ruleBoxLines(policy: Readonly<{ title: string; requiredAction: string }>): Readonly<{ title: string; detail: string | null }> {
  const detail = normalizeRuleText(policy.requiredAction);
  return detail.length === 0 || detail === normalizeRuleText(policy.title)
    ? { title: policy.title, detail: null }
    : { title: policy.title, detail: policy.requiredAction };
}
